<div fxFill fxLayout="column" fxLayoutAlign="start">
    <mat-toolbar color="primary" class="toolbar">
        <app-back-button color="secondary" [route]="['/home', 'perfil']"></app-back-button>
        <div>{{ "RECURRENCE_SUBSCRIPTION.TITLE" | translate }}</div>
    </mat-toolbar>

    <div class="menu" style="padding: 10px">
        <mat-form-field fxFill>
            <mat-label>{{ "RECURRENCE_SUBSCRIPTION.STATUS.LABEL" | translate }}</mat-label>
            <mat-select
                [id]="'select_profile_recurrence_subscriptions-Filters'"
                [multiple]="true"
                (selectionChange)="status$.next($event.source.value)"
            >
                <mat-option value="Active">
                    {{ "RECURRENCE_SUBSCRIPTION.STATUS.ACTIVE" | translate }}
                </mat-option>
                <mat-option value="Canceled">
                    {{ "RECURRENCE_SUBSCRIPTION.STATUS.CANCELED" | translate }}
                </mat-option>
                <mat-option value="Future">
                    {{ "RECURRENCE_SUBSCRIPTION.STATUS.FUTURE" | translate }}
                </mat-option>
                <mat-option value="Expired">
                    {{ "RECURRENCE_SUBSCRIPTION.STATUS.EXPIRED" | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayoutAlign="stretch">
        <mat-card class="mat-elevation-z3" *ngFor="let bill of bills$ | async">
            <mat-card-header>
                <mat-card-title>
                    {{ "RECURRENCE_SUBSCRIPTION.STATUS." + bill.status | uppercase | translate }}
                </mat-card-title>
                <mat-card-subtitle>
                    {{ bill.plan?.name }}
                </mat-card-subtitle>

                <mat-card-subtitle *ngIf="bill.paymentMethodCode">
                    {{ getPaymentMethodAlias(bill.paymentMethodCode) | translate }}
                </mat-card-subtitle>
                <mat-card-subtitle>
                    {{ bill.createdAt | date: "dd/MM/yyyy" }}
                </mat-card-subtitle>
                <mat-card-subtitle> {{ bill.plan.price | currency: "BRL" }} </mat-card-subtitle>
            </mat-card-header>

            <mat-card-actions align="end" *ngIf="bill.status !== 'Canceled'">
                <button mat-icon-button (click)="openCancelBillDialog(bill)">
                    <mat-icon>delete</mat-icon>
                </button>
            </mat-card-actions>
        </mat-card>
        <ghost-data [show]="loading">
            <mat-card class="mat-elevation-z3">
                <mat-card-header>
                    <mat-card-title>
                        <div class="loader"></div>
                        {{ "RECURRENCE_SUBSCRIPTION.LOADING" | translate }}
                    </mat-card-title>
                    <mat-card-subtitle>
                        <div class="loader"></div>
                        {{ "RECURRENCE_SUBSCRIPTION.LOADING" | translate }}
                    </mat-card-subtitle>
                    <mat-card-subtitle>
                        <div class="loader"></div>
                        {{ "RECURRENCE_SUBSCRIPTION.LOADING" | translate }}
                    </mat-card-subtitle>
                </mat-card-header>
            </mat-card>
        </ghost-data>
    </div>
</div>
